<template>
    <nav id="stickyNav">
        <div id="mob" v-if="isMobile">
            <div class="logo">
                <a href="#">
                    <img src="../assets/logoMob.png">
                </a>
            </div>
            <!-- <ul id="botones">
                <li class="op"><a @click="ver('institucional')">INSTITUCIONAL</a></li>
                <li class="op"><a @click="ver('capacitacion')">CAPACITACIÓN</a></li>
                <li class="op"><a @click="ver('noticias')">NOTICIAS</a></li>
                <li class="op"><a @click="ver('manual')">MANUAL</a></li>
            </ul> -->
            <Redes :links="redes.links" :isDark="true"></Redes>
            <div id="hambu" :class="{ open: isOpen }" @click="open">
                <span class="top"></span>
                <span class="mid"></span>
                <span class="mid"></span>
                <span class="down"></span>
            </div>
            <transition name="fade">
                <ul v-if="isOpen" class="list" :class="{ open: isOpen }">
                    <li class="limenu">
                        <a @click="[ver('institucional'), isOpen = false, scrollToTop()]">INSTITUCIONAL</a>
                    </li>
                    <li class="limenu">
                        <a @click="[ver('capacitacion'), isOpen = false, scrollToTop()]">CAPACITACIÓN</a>
                    </li>
                    <li class="limenu">
                        <a @click="[ver('noticias'), isOpen = false, scrollToTop()]">NOTICIAS</a>
                    </li>  
                    <li class="limenu">
                        <a @click="[ver('manual'), isOpen = false, scrollToTop()]">MANUAL</a>
                    </li>
                </ul>
            </transition>
            <!-- <div id="selSecc" v-show="see == 'noticias'">
                <select id="selectSeccion" class="select">
                    <option selected disabled value="0">Filtrá por sección</option>
                    <option value="secciones">Todos</option>
                    <option v-for="op in opciones" :key="op" :value="op"></option>
                </select>
            </div> -->
        </div>
        <div id="desk" v-else>
            <div class="logo">
                <a href="#">
                    <img src="../assets/logo.png">
                </a>
            </div>
            <ul id="menu">
                <li class="op" :class="{ act: see == 'institucional'}" @click="[ver('institucional'), scrollToTop()]">INSTITUCIONAL</li>
                <li class="op" :class="{ act: see == 'capacitacion'}" @click="[ver('capacitacion'), scrollToTop()]">CAPACITACIÓN</li>
                <li class="op" :class="{ act: see == 'noticias'}" @click="[ver('noticias'), scrollToTop()]">NOTICIAS</li>
                <li class="op" :class="{ act: see == 'manual'}" @click="[ver('manual'), scrollToTop()]">MANUAL</li>
            </ul>
            <!-- <div id="selSecc" v-show="see == 'noticias'">
                <select id="selectSeccion" class="select" @change="cambiaSel($event)" v-model="optionSel">
                    <option selected disabled value="0">Filtrá por sección</option>
                    <option value="all">Todos</option>
                    <option v-for="op in opciones" :key="op" :value="op">{{ op }}</option>
                </select>
            </div> -->
            <Redes :links="redes.links" :isDark="true"></Redes>
        </div>
        
	</nav>
</template>

<script>
import Redes from './Redes.vue'

export default {
    components: {
        Redes
    },
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        redes: {
            type: Object,
            default: () => {}
        },
        opciones: {
            type: Array,
            default: () => []
        },
        see: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            isOpen: false,
            open: () => this.isOpen = !this.isOpen,
            optionSel: 'all'
        }
    },
    methods: {
        ver(queVer){
            this.$emit('que-ver', queVer)
        },
        cambiaSel(event) {
            this.$emit('cambia-sel', event.target.value)
        },
        scrollToTop() {
            window.scrollTo(0,0);
        }
    },
    watch: {
        opciones: function(newVal) {
            let newArray = []
            if (newVal) {
                newVal.forEach(o => {
                newArray.push(o)
                })
            }
            let este = [...new Set(newArray)]
            return este
        },
        deep: true
    }
}
</script>

<style lang="scss" scoped>
nav#stickyNav{
    position: sticky;
    top: 0px;
    padding: 5px 0;
    pointer-events: all;
    opacity: 1;
    transition: opacity .3s;
	width: 100%;
	height: 100px;
	margin: auto;
	text-align: center;
	background-color: var(--white);
	z-index: 1000;

    @media screen and (max-width: 600px) {
        height: 80px;
    }

	&.sticky {
		position: fixed;
		width: 100%;
		top: 0;
		z-index: 100;
		height: 60px;
		padding-top: 10px;
		border-bottom: 1px solid var(--black);
	}
    #desk{
		max-width: 1100px;
		margin: auto;
        display: flex;
        flex-flow: row nowrap;
        justify-content:space-between;
        align-items: flex-start;

        .logo{
            margin: auto;
            // flex-grow: 1;
            img{
                margin-left: 0;
				width: 70px;		
			}
        }

        #menu{
            text-align: center;
            padding-inline-start: 0;
            margin: auto;
            // flex-grow: 2;
            .op{
                list-style-type: none;
                display: inline-block;
                padding: 5px 10px;
                margin: auto;
                cursor: pointer;

                &.act{
                    font-weight: 700;
                }

                &:hover{
                    color: var(--sate);
                }
            }
        }
        #selSecc{
			margin: auto;
            // flex-grow: 1;
		}
        .redes{
            margin: auto;
        }
    }
    #mob{
        margin: auto;
        display: flex;
        flex-flow: row nowrap;
        justify-content: space-evenly;
        align-items: center;
        background-color: rgba($color: #fff, $alpha: 0.6);
        height: 80px;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1000;
        -webkit-transition: .1s ease;
        -moz-transition: .1s ease;
        -o-transition: .1s ease;
        transition: .1s ease;

        &.open{
            background-color: rgba($color: #000, $alpha: 0.6);
            // background-image: linear-gradient(rgba(0,0,0,1), rgba(0,0,0,0));
        }

        .logo{
            z-index: 2500;
            img{
				width: 80px;
                @media screen and (max-width: 600px) {
                    width: 150px;
                }
                @media screen and (max-width: 400px) {
                    width: 100px;
                }
			}
        }
        #botones{
            text-align: center;
            // flex-grow: 2;
            .op{
                list-style-type: none;
                display: inline-block;
                padding: 5px 10px;
                margin: auto;
            }
        }
        #hambu{
            width: 40px;
            height: 40px;
            flex-direction: column;
            justify-content: space-evenly;
            // align-self: flex-end;
            position: relative;
            -webkit-transform: rotate(0deg);
            -moz-transform: rotate(0deg);
            -o-transform: rotate(0deg);
            transform: rotate(0deg);
            -webkit-transition: .5s ease;
            -moz-transition: .5s ease;
            -o-transition: .5s ease;
            transition: .5s ease;
            cursor: pointer;
            margin: 20px 0;
            @media screen and (max-width: 600px) {
                width: 50px;
                height: 35px;
                margin: 10px 0;
            }
            @media screen and (max-width: 400px) {
                width: 40px;
                height: 30px;
                // margin: 10px 0;
            }

            span{
                display: block;
                position: absolute;
                height: 8px;
                width: 100%;
                background: var(--black);
                opacity: 1;
                left: 0;
                -webkit-transform: rotate(0deg);
                -moz-transform: rotate(0deg);
                -o-transform: rotate(0deg);
                transform: rotate(0deg);
                -webkit-transition: .25s ease;
                -moz-transition: .25s ease;
                -o-transition: .25s ease;
                transition: .25s ease;
                @media screen and (max-width: 400px) {
                    height: 6px;
                }
            }

            span:nth-child(1) {
                top: 0px;
            }
            span:nth-child(2), span:nth-child(3) {
                top: 16px;
                @media screen and (max-width: 400px) {
                    top: 13px;
                }
            }
            span:nth-child(4) {
                top: 32px;
                @media screen and (max-width: 400px) {
                    top: 26px;
                }
            }

            &.open{
                z-index: 2000;
                span:nth-child(1) {
                    top: 16px;
                    width: 0%;
                    left: 50%;
                    background: var(--white);
                }
                span:nth-child(2) {
                    -webkit-transform: rotate(45deg);
                    -moz-transform: rotate(45deg);
                    -o-transform: rotate(45deg);
                    transform: rotate(45deg);
                    background: var(--white);
                }
                span:nth-child(3) {
                    -webkit-transform: rotate(-45deg);
                    -moz-transform: rotate(-45deg);
                    -o-transform: rotate(-45deg);
                    transform: rotate(-45deg);
                    background: var(--white);
                }
                span:nth-child(4) {
                    top: 16px;
                    width: 0%;
                    left: 50%;
                    background: var(--white);
                }
            }
        }
        .list{
            width: 100%;
            height: 0;
            background-color: var(--sate);
            padding: 10px;
            margin-top: 0px;
            position: fixed;
            top: 0px;
            -webkit-transition: .5s ease;
            -moz-transition: .5s ease;
            -o-transition: .5s ease;
            transition: .5s ease;

            .limenu{
                list-style: none;
                color: var(--white);
                text-align: right;
                margin-right: 50px;
                margin: 15px;
                &:first-child{
                    margin-top: 70px;
                }
                @media screen and (max-width: 600px) {
                    margin: 15px 0;
                }
                a{
                    color: var(--white);
                    text-decoration: none;
                    margin: 30px 65px;
                    font-size: 1rem;
                    font-family: var(--sans);
                    font-weight: 500;
                    letter-spacing: 5px;
                    position: relative;
                    -webkit-transition: .5s ease;
                    -moz-transition: .5s ease;
                    -o-transition: .5s ease;
                    transition: .5s ease;

                    &:after{
                        content: '';
                        position: absolute;
                        right: -70px;
                        top: 8px;
                        height: 5px;
                        width: 30px;
                        background-color: var(--white);
                        -webkit-transition: .5s ease;
                        -moz-transition: .5s ease;
                        -o-transition: .5s ease;
                        transition: .5s ease;
                    }
                    @media screen and (max-width: 600px) {
                        margin-right: 23%;
                    }
                    @media screen and (max-width: 400px) {
                        margin-right: 25%;
                    }
                }
            }

            &.open{
                -webkit-transition: .5s ease;
                -moz-transition: .5s ease;
                -o-transition: .5s ease;
                transition: .5s ease;
                height: 250px;

                &.fade-enter-active, &.fade-leave-active {
                    -webkit-transition: .5s ease;
                    -moz-transition: .5s ease;
                    -o-transition: .5s ease;
                    transition: .5s ease;
                }
                &.fade-enter {
                    opacity: 1;
                }
                &.fade-leave-to {
                    -webkit-transition: .5s ease;
                    -moz-transition: .5s ease;
                    -o-transition: .5s ease;
                    transition: .5s ease;
                    opacity: 0;
                }
            }
        }
    }

	// .cont{

	// 	#selSecc{
	// 		display: inline-block;
	// 		width: 17%;
	// 	}
		
	// 	.logo{
	// 		width: 10%;
	// 		display: inline-block;
	// 		vertical-align: middle;
	// 		text-align: left;

	// 		img{
	// 			width: 80px;		
	// 		}
	// 	}

	// 	p{
	// 		width: 5%;
	// 		display: inline-block;
	// 		font-weight: 100;
	// 		font-size: 15px;
	// 		text-align: right;
	// 		color: var(--black);
	// 		margin: auto;
	// 	}

	// 	ul{
	// 		height: 30px;
	// 		display: inline-block;
	// 		text-align: center;
	// 		margin: auto;
	// 		padding: 0;
	// 		vertical-align: middle;
	// 	}
		
	// 	.menu{
	// 		display: inline-block;
	// 		width: 62%;

	// 		ul#botones{
	// 			width: 100%;
				
	// 			li.bot{
	// 				width: calc(25% - 10px);
	// 				height: 30px;
	// 				font-weight: 400;
	// 				font-size: 15px;
	// 				list-style: none;
	// 				display: inline-block;
	// 				background-color: var(--white);
	// 				margin: auto;
	// 				text-align: center;
	// 				cursor: pointer;
	// 				vertical-align: middle;

	// 				a{
	// 					color: var(--black);
	// 					height: 20px;
	// 					text-decoration: none;
	// 					line-height: 30px;

	// 					&:link, &:visited{
	// 						color: var(--black);
	// 					}

	// 					&:hover{
	// 						color: #438ec4;
	// 					}

	// 					&.comision{
	// 						font-size: 14px;
	// 						letter-spacing: -0.5px;
	// 					}
	// 				}

	// 				&.active{
	// 					color: var(--white);
	// 					background-color: #438ec4;

	// 					a{
	// 						color: var(--white);

	// 						&:link, &:visited{
	// 							color: var(--white);
	// 						}

	// 						&:hover{
	// 							color: var(--white);
	// 						}
	// 					}
	// 				}

	// 				&#institucional{
	// 					#menuInsti{
	// 						width: 100%;
	// 						max-width: 1260px;
	// 						display: block;
	// 						position: relative;
	// 						margin: auto;

	// 						ul#botonesMenuInsti{
	// 							width: 100%;
	// 							position: absolute;
	// 							top: 0px;
	// 							left: 0px;

	// 							li.bot{
	// 								width: 100%;
	// 								height: 30px;
	// 								font-weight: 400;
	// 								font-size: 15px;
	// 								line-height: 30px;
	// 								list-style: none;
	// 								display: inline-block;
	// 								background-color: var(--white);
	// 								margin: auto;
	// 								text-align: center;
	// 								cursor: pointer;
	// 								vertical-align: middle;

	// 								a{
	// 									color: var(--black);
	// 									height: 20px;
	// 									text-decoration: none;
	// 									line-height: 30px;

	// 									&:link, &:visited{
	// 										color: var(--black);
	// 									}

	// 									&:hover{
	// 										color: #438ec4;
	// 									}
	// 								}

	// 								&.active{
	// 									color: var(--white);
	// 									background-color: #438ec4;

	// 									a{
	// 										color: var(--white);

	// 										&:link, &:visited{
	// 											color: var(--white);
	// 										}

	// 										&:hover{
	// 											color: var(--white);
	// 										}
	// 									}
	// 								}
	// 							}
	// 						}
	// 					}
	// 				}
	// 			}	
	// 		}
	// 	}

	// 	// #redes{
	// 	// 	width: 15%;
	// 	// 	display: inline-block;
	// 	// 	vertical-align: middle;

	// 	// 	ul{
	// 	// 		width: 100%;
	// 	// 		text-align: right;

	// 	// 		li.red{
	// 	// 			margin-left: 5px;
	// 	// 			display: inline-block;

	// 	// 			.fac, .twi{
	// 	// 				width: 40px;
	// 	// 				height: 30px;
	// 	// 				background-image: url('../assets/red.svg');
	// 	// 				display: inline-block;
	// 	// 				vertical-align: middle;
	// 	// 			}

	// 	// 			.fac{
	// 	// 				background-position: top left;
						
	// 	// 				&:hover{
	// 	// 					background-position: bottom left;
	// 	// 				}
	// 	// 			}

	// 	// 			.twi{
	// 	// 				background-position: top right;
						
	// 	// 				&:hover{
	// 	// 					background-position: bottom right;
	// 	// 				}
	// 	// 			}
	// 	// 		}
	// 	// 	}
	// 	// }
	// }
}
</style>